import { DawAudioSection } from './sections/DawAudioSection'
import { ComputerAudioSection } from './sections/ComputerAudioSection'
import { BasicSection } from './sections/BasicSection'
import { AdvancedOptionsSection } from './sections/AdvancedOptionsSection'
import { AutoMuteSection } from './sections/AutoMuteSection'
import { TalkbackSection } from './sections/TalkbackSection'
import { AdvancedInputsSection } from './sections/AdvancedInputsSection'

export function AudioSettings() {
    return (
        <div className="flex flex-col gap-[10px]">
            <BasicSection />
            <AdvancedInputsSection />
            <DawAudioSection />
            <ComputerAudioSection />
            <TalkbackSection />
            <AutoMuteSection />
            <AdvancedOptionsSection />
        </div>
    )
}
